import React from 'react'
import styles from './HeaderBackground.css'

export default function HeaderBackground () {
  return (
    <div className={styles.container}>
      <div className={styles.background} />
    </div>
  )
}
